// These must be the first lines in src/index.js
import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";

import Routes from "./Routes";

ReactDOM.render(
  // <React.StrictMode >
  <BrowserRouter>
    <div>{Routes}</div>
  </BrowserRouter>,

  // </React.StrictMode>
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
